// extracted by mini-css-extract-plugin
export var cityCard = "styles-module--cityCard--e7577";
export var cityName = "styles-module--cityName--af7e4";
export var grid = "styles-module--grid--1d426";
export var image = "styles-module--image--43ae6";
export var link = "styles-module--link--1483b";
export var title = "styles-module--title--39d9d";